// useFeatureFlag composable — 환경변수 기반 기능 플래그 (ux-patterns.md §12)
// @MX:SPEC: SPEC-ECOUNT-ETL-OPS-CONSOLE-001 REQ-OC-COMMON-002

/**
 * 환경변수 기반 feature flag
 * @param {string} envKey - process.env 키 (예: 'VUE_APP_ECOUNT_ETL_SYNC_TRIGGER')
 * @returns {boolean} - 플래그 활성 여부
 */
export function useFeatureFlag(envKey) {
  return process.env[envKey] === 'true';
}
